import i18n from 'modules/core/lib/i18n'

type AlertVariant = 'info' | 'warning'

export type BannerOptions = {
  title: string
  description: string
  variant: AlertVariant
}

export const bannerVariants = (usage: number, usageLimit: number): BannerOptions => {
  const available = Math.max(usageLimit - usage, 0)

  switch (available) {
    case usageLimit:
      return {
        title: i18n.t('project_management.sale_invoices.banners.zero_invoices.title'),
        description: i18n.t('project_management.sale_invoices.banners.zero_invoices.description', {
          limit: usageLimit,
        }),
        variant: 'info',
      }
    case 0:
      return {
        title: i18n.t('project_management.sale_invoices.banners.three_invoices.title', {
          limit: usageLimit,
        }),
        description: i18n.t('project_management.sale_invoices.banners.three_invoices.description'),
        variant: 'warning',
      }
    case 1:
      return {
        title: i18n.t('project_management.sale_invoices.banners.two_invoices.title', {
          usage: usage,
          limit: usageLimit,
        }),
        description: i18n.t('project_management.sale_invoices.banners.two_invoices.description', {
          available: available,
        }),
        variant: 'info',
      }
    default:
      return {
        title: i18n.t('project_management.sale_invoices.banners.one_invoice.title', {
          usage: usage,
          limit: usageLimit,
        }),
        description: i18n.t('project_management.sale_invoices.banners.one_invoice.description', {
          available: available,
        }),
        variant: 'info',
      }
  }
}
